// extracted by mini-css-extract-plugin
export var equalColumn = "_eo-0";